
import { CheckCircle2 } from "lucide-react";

interface DevotionalCompletionProps {
  daysCompleted: number;
  points: number;
  currentDay?: number;
}

export function DevotionalCompletion({
  daysCompleted,
  points,
  currentDay
}: DevotionalCompletionProps) {
  if (daysCompleted === 0) return null;

  return (
    <div className="text-center space-y-4 p-6 bg-gray-50 rounded-lg animate-fade-in">
      <CheckCircle2 className="w-12 h-12 text-green-500 mx-auto" />
      
      <div>
        <h2 className="text-2xl font-bold text-grace-dark mb-2">
          Day {currentDay} Completed! 🎉
        </h2>
        <p className="text-muted-foreground">
          You've earned {points} points for your spiritual journey
        </p>
      </div>

      <p className="text-sm text-muted-foreground pt-4">
        Come back tomorrow for your next devotional!
      </p>
    </div>
  );
}
